import { render, staticRenderFns } from "./AdminPermissions.vue?vue&type=template&id=006f8553&scoped=true"
import script from "./AdminPermissions.vue?vue&type=script&lang=ts"
export * from "./AdminPermissions.vue?vue&type=script&lang=ts"
import style0 from "./AdminPermissions.vue?vue&type=style&index=0&id=006f8553&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f8553",
  null
  
)

export default component.exports